import RootNavigation from '@routes/RootNavigation';
import React from 'react';

const RootNavigationContainer = () => {
  return <RootNavigation />;
};

export default RootNavigationContainer;
